import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { t } from 'i18n'

import ResourceListItem from 'Components/Resources/ResourceListItem'

const ResourcesSection = ({ selectedResources, selectedVideos, editResource, onDeleteResource, onDeleteVideo }) => {
  const hasResources = selectedResources && selectedResources.length > 0
  const hasVideos = selectedVideos && selectedVideos.length > 0
  const hasAny = hasResources || hasVideos

  return (
    <div className="item-pill-section">
      <h3 className="item-pill-section__header">
        {t('resources', { scope: 'care_plans.generic_order_section.generic_order' })}
      </h3>

      {hasAny ? (
        <Fragment>
          {hasResources && (
            <div className="item-pill-section__item-list">
              {selectedResources.map((resource) => (
                <ResourceListItem
                  key={resource.id}
                  id={resource.id}
                  name={resource.name}
                  kind={resource.kind}
                  editResource={editResource}
                  deleteResource={onDeleteResource}
                  isLinking
                />
              ))}
            </div>
          )}

          {hasVideos && (
            <div className="item-pill-section__item-list">
              {selectedVideos.map((video) => (
                <ResourceListItem
                  key={video.id}
                  id={video.id}
                  name={video.name}
                  kind="video"
                  editResource={editResource}
                  deleteResource={onDeleteVideo}
                  isLinking
                />
              ))}
            </div>
          )}
        </Fragment>
      ) : (
        <div className="item-pill-section--item-list-empty">
          <span>{t('no_resources_present', { scope: 'tasks.form' })}</span>
        </div>
      )}
    </div>
  )
}

ResourcesSection.propTypes = {
  editResource: PropTypes.func.isRequired,
  onDeleteResource: PropTypes.func,
  onDeleteVideo: PropTypes.func,
  selectedResources: PropTypes.array,
  selectedVideos: PropTypes.array,
}

ResourcesSection.defaultProps = {
  onDeleteResource: null,
  onDeleteVideo: null,
  selectedResources: [],
  selectedVideos: [],
}

export default ResourcesSection
